import image1 from '../../../../assets/Carousel_1_1.png';
import image2 from '../../../../assets/Carousel_1_2.png';
import image3 from '../../../../assets/Carousel_1_3.png';

export const slidesCollections: { image: string, title: string, info: string }[] = [
  {
    image: image1,
    title: 'New Arrivals',
    info: 'The latest styles and limited edition colors that you can only find here (while they last, that is).',
  },
  {
    image: image2,
    title: 'Natural Run Collection',
    info: 'Looking for sustainable ways to break a sweat? We’ve got you covered from head to toe.',
  },
  {
    image: image3,
    title: 'Fresh Long Sleeve',
    info: 'It’s crisp, clean and ready for wherever the day takes you. And whenever the day takes you.',
  },
  {
    image: image1,
    title: 'New Arrivals',
    info: 'The latest styles and limited edition colors that you can only find here (while they last, that is).',
  },
  {
    image: image2,
    title: 'Natural Run Collection',
    info: 'Looking for sustainable ways to break a sweat? We’ve got you covered from head to toe.',
  },
  {
    image: image3,
    title: 'Fresh Long Sleeve',
    info: 'It’s crisp, clean and ready for wherever the day takes you. And whenever the day takes you.',
  },
];
